module.exports = __webpack_public_path__ + "img/scheduling.1dac04d1.png";